import React from "react";
import { useAuth } from "./AuthProvider";
import { LogIn, LogOut, User as UserIcon } from "lucide-react";

export const AuthButton = () => {
  const { user, loading, login, logout } = useAuth();
  if (loading) return null;
  if (!user) {
    return (
      <button
        data-testid="auth-login-btn"
        onClick={login}
        className="inline-flex items-center gap-1.5 rounded-full bg-[#FDFBF7] text-[#0A090D] px-4 py-2 text-xs font-bold tracking-[0.15em] uppercase hover:brightness-95 transition-all"
      >
        <LogIn size={14} /> Sign in
      </button>
    );
  }
  return (
    <div className="flex items-center gap-2" data-testid="auth-user-chip">
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-black/40 border border-[#FF107A]/40">
        {user.picture ? (
          <img src={user.picture} alt="" className="w-6 h-6 rounded-full" />
        ) : (
          <div className="w-6 h-6 rounded-full bg-[#FF107A]/30 flex items-center justify-center text-[#FF107A]">
            <UserIcon size={12} />
          </div>
        )}
        <span className="text-xs font-semibold truncate max-w-[80px]">{user.name}</span>
        <span className="text-[9px] tracking-[0.2em] uppercase text-[#FFD700]" data-testid="auth-user-rating">
          {user.prime_rating || 1200}
        </span>
      </div>
      <button
        data-testid="auth-logout-btn"
        onClick={logout}
        aria-label="Log out"
        className="w-8 h-8 rounded-full bg-black/40 border border-white/15 text-[#FDFBF7]/70 hover:text-[#FF107A] hover:border-[#FF107A] flex items-center justify-center"
      >
        <LogOut size={12} />
      </button>
    </div>
  );
};
